/**
 * Hero Centered Template
 *
 * A simple centered hero section with heading, subheading, and CTA button.
 */

// eslint-disable-next-line no-unused-vars
const heroCentered = {
  id: 'hero-centered',
  name: 'Centered Hero',
  category: 'hero',
  description: 'Simple centered hero with heading, subtext, and CTA button',
  thumbnail: null,
  content: {
    section_type: 'layout-1',
    sectionBackgroundColor: 'transparent',
    backgroundImage: '',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginTop: '0',
    marginBottom: '16',
    paddingTop: '60',
    paddingBottom: '60',
    paddingLeft: '24',
    paddingRight: '24',
    components: [
      {
        id: 'hero-centered-row-1',
        type: 'row',
        props: {
          direction: { base: 'horizontal', tablet: null, desktop: null },
          gap: 'md',
          alignment: 'stretch',
          justifyContent: 'center',
          flexWrap: 'wrap',
          columnLayout: { base: 'equal', tablet: null, desktop: null },
          columnWidths: [],
          width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          maxWidth: { base: { value: '800', unit: 'px' }, tablet: null, desktop: null },
          padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
          margin: { base: { top: 0, bottom: 0, left: 'auto', right: 'auto', unit: 'px' }, tablet: null, desktop: null },
          backgroundColor: 'transparent',
          backgroundImageUrl: '',
          borderWidth: 0,
          borderStyle: 'solid',
          borderColor: 'transparent',
          borderRadius: 0,
          overflow: 'visible',
          visibility: { base: true, tablet: null, desktop: null },
          position: 'relative',
          top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          zIndex: 'auto',
          customCSS: '',
        },
        children: [
          {
            id: 'hero-centered-col-1',
            type: 'column',
            props: {
              gap: 'lg',
              alignItems: 'center',
              justifyContent: 'center',
              span: { base: 12, tablet: null, desktop: null },
              width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
              padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              {
                id: 'hero-centered-heading',
                type: 'text',
                props: {
                  content: 'Your Headline Here',
                  element: 'h1',
                  fontFamily: 'System Default',
                  fontSize: 48,
                  fontWeight: 'bold',
                  lineHeight: 1.2,
                  letterSpacing: 0,
                  color: '#1a1a1a',
                  textAlign: 'center',
                  textTransform: 'none',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 16, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
              {
                id: 'hero-centered-subheading',
                type: 'text',
                props: {
                  content: 'Supporting text goes here',
                  element: 'p',
                  fontFamily: 'System Default',
                  fontSize: 18,
                  fontWeight: 'normal',
                  lineHeight: 1.5,
                  letterSpacing: 0,
                  color: '#666666',
                  textAlign: 'center',
                  textTransform: 'none',
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 24, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
              {
                id: 'hero-centered-button',
                type: 'button',
                props: {
                  text: 'Get Started',
                  url: '',
                  openInNewTab: false,
                  variant: 'primary',
                  size: 'md',
                  fullWidth: false,
                  backgroundColor: '#1a1a1a',
                  textColor: '#ffffff',
                  hoverBackgroundColor: '#333333',
                  fontFamily: 'System Default',
                  fontSize: 16,
                  fontWeight: '600',
                  padding: { base: { top: 12, bottom: 12, left: 24, right: 24, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 8,
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'static',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default heroCentered;
